import { useEffect } from 'react';
import Raven from 'raven-js';
import { useGetAppIdsQuery } from '../../../../__generated__/chirp/com/hubspot/dashworks/rpc/DashworksRpc.hooks';
export const useDashworksAppIds = args => {
  var _args$skip;
  const {
    data,
    loading,
    error,
    networkStatus
  } = useGetAppIdsQuery({
    skip: (_args$skip = args === null || args === void 0 ? void 0 : args.skip) !== null && _args$skip !== void 0 ? _args$skip : false
  });
  useEffect(() => {
    if (error) {
      Raven.captureException(error);
    }
  }, [error]);
  return {
    data: (data === null || data === void 0 ? void 0 : data.appIds) || [],
    isLoading: loading,
    error: error || null,
    networkStatus
  };
};